<template>
    <div class="mb-3">
        <div class="custom-div-outer">
            <b-row class="custom-outer-filter">
                <b-col md="4">
                    <b-form-group label="Hub Name" :label-cols="3">
                        <div id='container' style="width: 230px;">
                            <ejs-multiselect  id='multi_select2'  placeholder="Select Hub Name" v-model="valueWH" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                            ></ejs-multiselect>
                        </div>
                    </b-form-group>
                </b-col>

                <b-col md="4">
                    <b-form-group label="Select From Date:"  :label-cols="5" >
                        <v-date-picker mode='single' input-class="dateInput"
                        :available-dates='{ start: null, end: new Date() }'
                        v-model='selectFromDate'>
                        </v-date-picker>
                    </b-form-group>
                </b-col>

                <b-col md="4">
                    <b-form-group label="Select To Date:"  :label-cols="5" >
                        <v-date-picker mode='single' input-class="dateInput"
                        :available-dates='{ start: null, end: new Date() }'
                        v-model='selectToDate'>
                        </v-date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-col md="12" class="mb-5 text-right">
                <b-button variant="primary" @click="getFilterList()"> Search </b-button>&nbsp;
                <b-button variant="danger" @click="clearFilter(activeTab)"> Clear </b-button>&nbsp;
            </b-col>
            
        </div> 
        

        <b-row>
            <b-col md="12">
                <div>
                    <ul class="nav nav-tabs nav-justified mb-3">
                        <li class="nav-item">
                            <a @click="activeTab = 0" class="nav-link text-center custom-link" :class="{'active': isActiveTab(0)}">
                                <div>Vendor Pending - {{ allvendor_pending_count }}</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="activeTab = 1"  class="nav-link text-center custom-link" :class="{'active' : isActiveTab(1)}">
                                <div>Vendor Reconsider - {{ allvendor_reconsider_count }}</div>
                            </a>
                        </li>
                    </ul>
                </div>
            </b-col>
  
            <b-col md="12">
                <div class="tab-panel" v-if="isActiveTab(0)">
                    <b-table responsive show-empty :fields="fields" :items="freightPendingRequest" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                        <template slot="requestid" slot-scope="row">
                            <div>
                                <button class="cutom-view-all-btn" @click.prevent="viewPlanDetails(row.item.planid, pageNum)"><strong>{{ row.item.requestid }}</strong></button>
                            </div>
                        </template>
                        <template slot="delivery_locations" slot-scope="row">
                            <div>
                                <b-button v-b-tooltip.hover :title="row.item.delivery_locations" class="cutom-view-all-btn">{{ row.item.delivery_locations.split(',').slice(0, 2).join(', ') }}</b-button>
                            </div>
                        </template>
                        <template slot="status" slot-scope="row">
                            <div>
                                <strong>{{ row.item.status }}</strong>
                            </div>
                        </template>
                        <template slot="basefreight" slot-scope="row">
                            <div>
                                <span v-if="row.item && row.item.basefreight" class="cutom-view-all-btn">{{ row.item.basefreight }}</span>
                                <span v-else class="cutom-view-all-btn">NA</span>
                            </div>
                        </template>
                        <template slot="vendorlist" slot-scope="row">
                                <router-link :to="{ name: 'AdhocVehicleFreightApproval', params: { id: row.item.requestid } }">
                                <b-button variant="primary">{{row.item.transporter_company_name}} {{row.item.freight}} <i class="fa fa-clipboard" aria-hidden="true"></i></b-button>
                                </router-link>
                                <div>
                                <router-link :to="{ name: 'AdhocVehicleFreightApproval', params: { id: row.item.requestid }, query: { flag: 'showpopup' } }">
                                    <b-button class="shrek-color mt-1" size="sm">
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                </b-button> &nbsp; 
                                </router-link>

                                <router-link :to="{ name: 'AdhocVehicleFreight', params: { id: row.item.requestid }, query: { flag: 'showpopup' } }">
                                <b-button class="mt-1" variant="danger" size="sm">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </b-button>
                            </router-link>
                            </div>
                        </template>
                        <template slot="lastmodifieddate" slot-scope="row">
                            <div>
                                {{row.item.lastmodifiedby + ' ' + row.item.lastmodifieddate}} 
                            </div>
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </b-table>

                    <!-- pagination -->
                    <paginate v-model="pendingpageNum"
                        :page-count="pendingnoofpages"
                        :page-range="10"
                        :margin-pages="2"
                        :click-handler="pendingClickCallback"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                    </paginate>

                </div>


                <div class="tab-panel" v-if="isActiveTab(1)">
                    <b-table responsive show-empty :fields="fieldsApproved" :items="vendorPendingRequest" :busy="reisBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                        <template slot="requestid" slot-scope="row">
                            <div>
                                <button class="cutom-view-all-btn" @click.prevent="viewPlanDetails(row.item.planid, pageNum)"><strong>{{ row.item.requestid }}</strong></button>
                            </div>
                        </template>
                        <template slot="delivery_locations" slot-scope="row">
                            <div>
                                <b-button v-b-tooltip.hover :title="row.item.delivery_locations" class="cutom-view-all-btn">{{ row.item.delivery_locations.split(',').slice(0, 2).join(', ') }}</b-button>
                            </div>
                        </template>
                        <template slot="status" slot-scope="row">
                            <div>
                                <strong>{{ row.item.status }}</strong>
                            </div>
                        </template>
                        <template slot="basefreight" slot-scope="row">
                            <div>
                                <span v-if="row.item && row.item.basefreight" class="cutom-view-all-btn">{{ row.item.basefreight }}</span>
                                <span v-else class="cutom-view-all-btn">NA</span>
                            </div>
                        </template>
                        <template slot="vendorlist" slot-scope="row">
                            <div>
                                <router-link :to="{ name: 'AdhocVehicleFreight', params: { id: row.item.requestid } }">
                                    <b-button variant="primary"><i class="fa fa-clipboard" aria-hidden="true"></i></b-button>
                                </router-link>
                            </div>
                        </template>
                        <template slot="lastmodifieddate" slot-scope="row">
                            <div>
                                {{row.item.lastmodifiedby + ' ' + row.item.lastmodifieddate}} 
                            </div>
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </b-table>

                     <!-- pagination -->
                     <paginate v-model="reconsidepageNum"
                     :page-count="reconsidenoofpages"
                     :page-range="10"
                     :margin-pages="2"
                     :click-handler="reconsideClickCallback"
                     :prev-text="'Prev'"
                     :next-text="'Next'"
                     :container-class="'pagination'"
                     :page-class="'page-item'">
                 </paginate>
                </div>

            </b-col>
        </b-row>

        <!-- plan modal start here -->
        <b-modal :title="'View Plan Screen'" v-model="plandetailsmodal" size="xl" hide-footer modal-class="modal-center-title">
            
            <template slot="default" slot-scope="{ hide }">
                <template>
                    <b-row>
                        <b-col sm="4">
                            <b-input-group>
                                <b-input-group-prepend>
                                    <span class="d-flex text-center m-auto mr-2"><strong>Search Load :- </strong></span> &nbsp;
                                </b-input-group-prepend>&nbsp;
                                <b-form-input v-model="filter" placeholder="Enter Parent AWB / Load ID" @input="searchdata"></b-form-input>
                                <b-input-group-append>
                                    <b-button :disabled="!filter" @click="clearFilterPlan">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col  sm="3">
                            <strong>vehicle No :- </strong> <b v-if="planScrrenDetails && planScrrenDetails[0] && planScrrenDetails[0].vehicle_no">{{ planScrrenDetails[0].vehicle_no }}</b>
                        </b-col>
                        <b-col  sm="3">
                            <strong>Origin :- </strong> <b v-if="planScrrenDetails && planScrrenDetails[0] && planScrrenDetails[0].origin">{{ planScrrenDetails[0].origin }}   </b>
                        </b-col>
                        <b-col  sm="2">
                            <strong>Records :- </strong> <b class="text-danger">{{planScrrenDetails_count}}</b>
                        </b-col>
                    </b-row>
                </template>

                <b-table responsive show-empty :fields="fieldsPlanScrren" :items="planScrrenDetails" :filter="filter" :busy="planisBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                    <template slot="parentawb" slot-scope="row">
                        <div>
                            <span class="cutom-view-plan-btn">{{ row.item.parentawb }}</span>
                        </div>
                    </template>
                    <template slot="mpscount" slot-scope="row">
                        <div>
                            <span class="cutom-view-plan-btn">{{ row.item.mpscount }}</span>
                        </div>
                    </template>
                    <template slot="userid" slot-scope="row">
                        <div>
                            <span class="cutom-view-plan-btn">{{ row.item.userid }}</span>
                        </div>
                    </template>
                    <template slot="totalcount" slot-scope="row">
                        <div>
                            <span class="cutom-view-plan-btn">{{ row.item.totalcount }}</span>
                        </div>
                    </template>
                        <template slot="requestid" slot-scope="row">
                        <div>
                            <button class="cutom-view-all-btn" @click.prevent="viewPlanDetails(row.item.planid, pageNum)"><strong>{{ row.item.requestid }}</strong></button>
                        </div>
                    </template>
                    <template slot="status" slot-scope="row">
                        <div>
                            <button class="cutom-btn-download" @click.prevent="downloadCSV(row.item)"><i class="fa fa-file" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                    <!-- <template #table-caption><b>Incidents Listed</b></template> -->
                </b-table>   
                <!-- pagination -->
                <paginate v-model="pageNum"
                        :page-count="noofpages"
                        :page-range="10"
                        :margin-pages="2"
                        :click-handler="clickCallback"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                    </paginate>             
            </template>
                                
            <template slot="modal-footer" slot-scope="{ hide }">
                <b-button size="sm" style="display:none">
                    Cancel
                </b-button>
            </template>
        </b-modal>
        <!-- plan modal end here -->                    
    </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Swal from 'sweetalert2';
export default {
  name: 'MyTabs',
  data () {
        return {
            activeTab: 0, // The first tab is active by default //
            fields : [ 
                { key : 'requestid', label : 'Request ID', sortable: true},
                { key : 'origin', label : 'Origin', sortable: true},
                { key : 'route', label : 'Route', sortable: true},
                { key : 'vehicle_size', label : 'Vehicle Size', sortable: true},
                { key : 'delivery_locations', label : 'Delivery Locations', sortable: true},
                { key : 'delivery_points', label : 'Delivery Points', sortable: true},
                { key : 'volumetric_wt', label : 'Volumetric Wt.', sortable: true},
                { key : 'createdby', label : 'Request By', sortable: true},
                { key : 'createddate', label : 'Request Date and Time', sortable: true},
                { key : 'status', label : 'Request Status', sortable: true},
                { key : 'lastmodifieddate', label : 'Last modified By & On', sortable: true},
                { key : 'basefreight', label : 'Base Freight', sortable: true},
                { key : 'vendorlist', label : 'Suggested Vendor', sortable: true},
            ],
            fieldsApproved: [ 
                { key : 'requestid', label : 'Request ID', sortable: true},
                { key : 'origin', label : 'Origin', sortable: true},
                { key : 'route', label : 'Route', sortable: true},
                { key : 'vehicle_size', label : 'Vehicle Size', sortable: true},
                { key : 'delivery_locations', label : 'Delivery Locations', sortable: true},
                { key : 'delivery_points', label : 'Delivery Points', sortable: true},
                { key : 'volumetric_wt', label : 'Volumetric Wt.', sortable: true},
                { key : 'createdby', label : 'Request By', sortable: true},
                { key : 'createddate', label : 'Request Date and Time', sortable: true},
                { key : 'status', label : 'Request Status', sortable: true},
                { key : 'lastmodifieddate', label : 'Last modified By & On', sortable: true},
                { key : 'basefreight', label : 'Base Freight', sortable: true},
                { key : 'transporter_company_name', label : 'Currently Suggested Vendor', sortable: true},
                { key : 'vendorlist', label : 'Vendor Listing', sortable: true},
            ],
            fieldsPlanScrren : [ 
                { key : 'parentawb', label : 'Parent AWB', sortable: true, sortDirection: "desc"},
                { key : 'load_id', label : 'Load ID', sortable: true, sortDirection: "desc"},
                { key : 'mpscount', label : 'MPS Count', sortable: true, sortDirection: "desc"},
                { key : 'destinationaddress', label : 'Destination Address', sortable: true, sortDirection: "desc"},
                { key : 'userid', label : 'User ID', sortable: true, sortDirection: "desc"},
                { key : 'destinationcity', label : 'Destination City', sortable: true, sortDirection: "desc"},
                { key : 'unload_sequence', label : 'Sequence', sortable: true, sortDirection: "desc"},
                { key : 'status', label : 'Download PDF(Invoice)', sortable: true, sortDirection: "desc"},
            ],
            freightPendingRequest: [],
            pending_count: 0,
            vendorPendingRequest: [],
            ApprovedRequest_count: 0,
            vehiclePendingList: [],
            vehicleUpdated_count:0,
            vehicleRejected: [],
            vehicleRejected_count: 0,
            valueWH:[],
            fieldWH:{ text: 'name', value: 'id' },
            optionsWH:[],
            WHData:[],
            showSelectAll : true,
            selectFromDate : null,
            selectToDate:  null,
            plandetailsmodal: false,
            totalRows:0,
            isBusy:false,
            reisBusy:false,
            planisBusy:false,
            bordered:true,
            pageOptions: [5, 10, 15],
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            activeTab: 0,

            allvendor_pending_count:0,
            allvendor_reconsider_count:0,

            vehicleReconsider: [],

            // 1st pagination
            pendingnoofpages:'',
            pendingpageNum:1,

            //2nd tab pagination
            reconsidenoofpages:'',
            reconsidepageNum:1,

            // model pagination
            noofpages:'',
            pageNum:1,

            rejectnoofpages:'',
            rejectpageNum:1,

            approvenoofpages:'',
            approvepageNum:1,

            isSearch:false,
        }
  },
  mounted(){
        this.getVendorPendingList(1);
        this.showWHlist();
        this.pendingTabCount();
    },
    created() {
        this.isActiveTab(0);
    },
    watch: {
    activeTab(newTab, oldTab) {
        this.pendingpageNum=1;
        this.reconsidepageNum=1;
        this.isSearch = false;
      // If switching away from the first tab (Pending Request)
      if (newTab === 0) {
        this.getVendorPendingList(1);
      }
      // If switching to the second tab (Approval Request)
      if (newTab === 1) {
        this.fetchVendorReconsiderData(1);
      }
    },
  },
  methods: {


    isActiveTab(id)
        {
        return this.activeTab === id
        },

        // fetch pending list
        pendingClickCallback (pageNum){
            this.pendingpageNum = pageNum;
            this.getVendorPendingList(pageNum);
        },

        getVendorPendingList : function (pageNo) {
            this.isBusy=true;
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var fromdate = (this.selectFromDate!=null)?this.formatDate(this.selectFromDate):null;
            var formatdateto=(this.selectToDate!=null)? this.formatDate(this.selectToDate):null;


            if(formatdateto< fromdate){  
              this.$fire({
                      text:"To date need to be greater than From date",
                      type: "warning",
                      timer: 30000
                    }); 
                    document.getElementById("overlay").style.display = "none";
                    this.isBusy = false; 
                    return false;       
            }

            const obj = {
                // sysusermasterid: this.isSearch ? null : `${userInfo.sysusermasterid}`,
                sysusermasterid: null,
                tab: 4,
                // status: 'Approval Pending',
                pageno: `${pageNo}`,
                hubid: this.valueWH && this.valueWH.length === 0 ? [] : this.valueWH,
                fromdate: fromdate,
                todate: formatdateto,
                subtab: "Vendor Pending"
            };

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAdhocVehilceRequestsList`,obj).then(result => {
                this.isBusy = false; 
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    this.freightPendingRequest = result.body.returnvalue;
                    // this.vendor_pending_count = result.body.returnvalue[0].totalcount;
                    let pending_count = result.body.returnvalue[0].totalcount;
                    this.pendingnoofpages=parseInt(pending_count)/10;
                    this.pendingnoofpages=Math.ceil( this.pendingnoofpages);
                } else {
                    this.pendingnoofpages='';
                    // this.vendor_pending_count = 0;
                    this.freightPendingRequest =[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        // fetch approval Request data

        reconsideClickCallback(pageNum){
            this.reconsidepageNum = pageNum;
            this.fetchVendorReconsiderData(pageNum);
        },

        fetchVendorReconsiderData: function (pageNo) {
            this.reisBusy = true; 
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
        

            var fromdate = (this.selectFromDate!=null)?this.formatDate(this.selectFromDate):null;
            var formatdateto=(this.selectToDate!=null)? this.formatDate(this.selectToDate):null;


            if(formatdateto< fromdate){  
              this.$fire({
                      text:"To date need to be greater than From date",
                      type: "warning",
                      timer: 30000
                    }); 
                    document.getElementById("overlay").style.display = "none";
                    this.reisBusy = false; 
                    return false;       
            }


            const obj = {
                // sysusermasterid: this.isSearch ? null : `${userInfo.sysusermasterid}`,
                sysusermasterid: null,
                tab: 4,
                // status: 'Approval Pending',
                pageno: `${pageNo}`,
                hubid: this.valueWH && this.valueWH.length === 0 ? [] : this.valueWH,
                fromdate: fromdate,
                todate: formatdateto,
                subtab: "Vendor Reconsider"
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAdhocVehilceRequestsList`,obj).then(result => {
                this.reisBusy = false; 
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    this.vendorPendingRequest = result.body.returnvalue;
                    // this.vendor_reconsider_count = result.body.returnvalue[0].totalcount;
                    let count = result.body.returnvalue[0].totalcount;
                    this.reconsidenoofpages=parseInt(count)/10;
                    this.reconsidenoofpages=Math.ceil( this.reconsidenoofpages);
                } else {
                    this.reconsidenoofpages='';
                    // this.vendor_reconsider_count = 0;
                    this.vendorPendingRequest = [];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },


        showWHlist:function(){
          
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          
          var csvObj = {
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype:`${userInfo.user_type}`
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj)
            .then(result => {
              
              if (result.body.returnmsg === 'Successful') {
                  this.optionsWH=[];
              
                  this.WHData  = result.body.returnvalue;
                  
                  for(let j = 0; j < this.WHData.length; j++) {
                      let WH = {
                      name: this.WHData[j].hubname + " - " + this.WHData[j].hubid,
                      id: this.WHData[j].hubid,
                      }
                  this.optionsWH.push(WH);
                  }
              
              } else {              
                  this.WHData  = result.body.returnvalue;
              }
          

          })
          .catch(ex => {
              console.log("error-----", ex);
          });
      },

      getFilterList() {
        this.isSearch = true;
        this.pendingTabCount();
        this.pendingpageNum=1;
        this.reconsidepageNum=1;
        if (this.activeTab === 0) {
            this.getVendorPendingList(1)
        }
        if (this.activeTab === 1) {
            this.fetchVendorReconsiderData(1)
        }
        
      },

      clearFilter(active) {
        this.pendingTabCount();
        this.pendingpageNum=1;
        this.reconsidepageNum=1;
        this.selectToDate = null;
        this.selectFromDate= null;
        this.valueWH= [];
        if (this.activeTab === active) {
            this.getVendorPendingList(1)
        }

        if (this.activeTab === active) {
            this.fetchVendorReconsiderData(1)
        }
        
      },

    clickCallback (pageNum){
        this.listingpageno = pageNum;
        this.viewPlanDetails(planid, pageNum);
    },

        //  plan details 
      viewPlanDetails(plainid, pageNum) {
        this.planisBusy=true;
        this.plandetailsmodal = ! this.plandetailsmodal;
        this.vehicleUpdated_count = [];
            // document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
        
            const obj = {
                planid: `${plainid}`,
                // planid: "101",
                pageno: pageNum,
            };

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getPlanDetailsForRequest`,obj).then(result => {
                this.planisBusy=false;                                                          
                // document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    this.planScrrenDetails = result.body.returnvalue;
                    this.planScrrenDetails_count = this.planScrrenDetails.length;
                    this.noofpages=parseInt(this.planScrrenDetails_count)/10;
                    this.noofpages=Math.ceil( this.noofpages);
                } else {
                    this.planScrrenDetails =[]
                    this.planScrrenDetails_count = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        
      },

      // count of all tab
      pendingTabCount() {
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
        
            const obj = {
                "tab": 4,
                "sysusermasterid": null,
            };

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAdhocVehicleRequestsCount`,obj).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log(result.body, 'aaabb adhoc');
                    this.allvendor_pending_count = result.body.returnvalue['Vendor Pending'];
                    this.allvendor_reconsider_count = result.body.returnvalue['Vendor Reconsider'];
                } else {
                    this.allvendor_pending_count = 0;
                    this.allvendor_reconsider_count = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
      },

      // format Date function
      formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");

        },
        downloadCSV(value){
            this.loadermodel=true;
            console.log("value",value)
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            let parent = [];

            parent.push(value.parentawb)

            let obj = {
                parentawb:parent,
                userId: value.userid,
                platform: "web"
            }

            // return false;
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/downloadAllDocAWBWise`,obj)
                .then((result) => {
                    this.loadermodel=false;
                    if (result.body.returnmsg === 'Successful') {
                        this.$fire({
                            text: result.body.returnvalue,
                            type: "success",
                            timer: 30000
                        });
                        
                    } else {
                        this.$fire({
                            text: result.body.returnvalue,
                            type: "error",
                            timer: 30000
                            });
                    
                    }
                }).catch((ex) => {
                    console.log('error-----', ex)
                })
        },

  }
};
</script>


<style scoped>
.cutom-btn-download {
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 15px;
    background: #f09642 !important;
    border: 1px solid #f09642 !important;
}

.tab-content {
margin-top: 20px;
}

.nav-link {
    color: #6c757d;  /* Customize the text color */
    background-color: #f8f9fa; /* Customize the background */
    border-color: #dee2e6;    
}
.tabs .nav-tabs {
    display: flex;
    justify-content: center; /* Centers the tabs horizontally */
    align-items: center; /* Centers the content vertically */
}


.custom-outer-filter {
    padding-top: 25px;
    padding-left: 15px;
}


.cutom-view-all-btn {
border: none !important;
border-radius: 10px !important;
margin-left: 15px !important;
background-color: #E8E4E4 !important;
}

.cutom-view-all-btn:focus {
border: none !important;
border-radius: 10px !important;
margin-left: 15px !important;
outline: none !important;
background-color: #E8E4E4 !important;
box-shadow: none !important;
}

.nav-link {
    background: #66635BAD !important;
    border-radius: 10px !important;
    margin-bottom: 20px;
  }
  .nav-link.active {
    background-color: #66635BAD !important;
    background: #00BDF0 !important;
    margin-bottom: 20px;
}


.nav-link {
        background: #7B7B7B !important;
        border-radius: 20px;
        border: none;
    }
    .nav-link.active {
        background: #F8943F !important;
    border-radius: 20px;
    border: none;
  }

  .nav-tabs {
    border-bottom: none !important;
}

.custom-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.custom-link i {
    font-size: 24px; /* Adjust icon size */
    margin-bottom: 5px; /* Add space between icon and text */
    color: #fff; /* Set icon color to white */
}

.custom-link div {
    font-size: 16px; /* Adjust text size */
    color: #fff !important;
}
.cutom-view-plan-btn {
    background: #DAE7FA !important;
    align-items: center;
    border-radius: 5px;
    border: none;
    color: #276F97 !important;
    padding: 4px;
}
.cutom-view-plan-btn:focus {
    background: #DAE7FA !important;
    align-items: center;
    border-radius: 5px;
    border: none;
    color: #276F97 !important;
    padding: 4px;
}

.modal-center-title .modal-header {
    justify-content: center;
    width: 100%;
}

.modal-center-title .modal-title {
    text-align: center;
    width: 100%;
}

.btn-danger {
    color: #fff !important;
    background-color: #f86c6b !important;
    border-color: #f86c6b !important;
}
.shrek-color, .shrek-color:hover ,.shrek-color:active, .shrek-color:not(:disabled):not(.disabled):active{
    color: #fff !important;
    background-color:  #B0C400 !important;
    border-color: #B0C400 !important;
}
.shrek-color:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem #B0C400(175, 181, 186, 0.5) !important;
}

</style>